export default "__VITE_ASSET__CXUS8hGh__"